import React from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FieldArray } from 'formik';

import { Form as FormikForm } from 'formik-antd';

import { Fieldset } from 'components/form';

import StagePropTypes from './prop-types';
import { DB_PREFIX_REFEREES, DB_PREFIX_REFERENCES } from './constants';
import ReferenceInput from './reference-input';
import Row from './row';

const Form = ({
  children,
  values,
  setFieldValue,
  uploadTo,
  isSubmitting,
  errors,
}) => {
  return (
    <FormikForm layout="vertical">
      <h2>Referees</h2>

      <FieldArray
        name={DB_PREFIX_REFEREES}
        render={(arrayReferees) => (
          <>
            {values[DB_PREFIX_REFEREES].map((referee, i) => {
              return (
                <Row
                  key={i}
                  i={i}
                  values={values}
                  arrayHelpers={arrayReferees}
                  setFieldValue={setFieldValue}
                />
              );
            })}

            <Fieldset>
              <Button
                style={{ width: '100%' }}
                type="dashed"
                onClick={() =>
                  arrayReferees.push({
                    name: '',
                    role: '',
                    organisation: '',
                    telephone: '',
                    email: '',
                  })
                }
              >
                <PlusOutlined /> Add referee
              </Button>
            </Fieldset>
          </>
        )}
      />

      <Divider />

      <h2>References</h2>

      <FieldArray
        name={DB_PREFIX_REFERENCES}
        render={(arrayReferences) => (
          <>
            {values[DB_PREFIX_REFERENCES].map((reference, i) => {
              return (
                <ReferenceInput
                  key={i}
                  i={i}
                  name={'Reference ' + (i+1)}
                  values={values}
                  uploadTo={uploadTo}
                  setFieldValue={setFieldValue}
                  arrayHelpers={arrayReferences}
                  isSubmitting={isSubmitting}
                  errors={errors}
                  {...reference}
                />
              );
            })}

            <Fieldset>
              <Button
                style={{ width: '100%' }}
                type="dashed"
                onClick={() =>
                  arrayReferences.push({
                    fileURL: '',
                  })
                }
              >
                <PlusOutlined /> Add reference
              </Button>
            </Fieldset>
          </>
        )}
      />

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  uploadTo: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

Form.defaultProps = {
  children: null,
};

export default Form;
